import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { Contractor } from "./entity/human-resource-agent.entity";
import { ContractorAdapter } from "./human-resource-agent.adapter";
import { ContractorController } from "./human-resource-agent.controller";
import { ContractorService } from "./human-resource-agent.service";

@Module({
    imports: [
      TypeOrmModule.forFeature([Contractor]),
    ],
    controllers: [ContractorController],
    providers: [ContractorService, ContractorAdapter, ApplicationExceptionHandler],
    exports: [ContractorService]
  })
  export class ContractorModule {}